import { SeverityLevel } from "../../model/enums";

export const logLevels = [
  { label: "Debug", value: SeverityLevel.DEBUG },
  { label: "Info", value: SeverityLevel.INFO },
  { label: "Warning", value: SeverityLevel.WARN },
  { label: "Error", value: SeverityLevel.ERROR }
];
